import React, { useState, useEffect } from "react";
import { useTournamentSteps } from "../../hooks/useTournamentSteps";
import MilestoneProgress from "./MilestoneProgress";

const Milestone = ({ tournamentId, canManage }) => {
  const { getAllSteps, getPublicSteps, loading, error } =
    useTournamentSteps(tournamentId);
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.innerWidth < 768
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (loading) {
    return (
      <div className="animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-3/4 mb-3"></div>
        <div className="flex gap-2">
          <div className="h-2 bg-gray-200 rounded flex-1"></div>
          <div className="h-2 bg-gray-200 rounded flex-1"></div>
          <div className="h-2 bg-gray-200 rounded flex-1"></div>
        </div>
      </div>
    );
  }
  
  if (error) return <p className="text-red-500">Error loading milestones.</p>;

  // Choose which milestones to display based on user permissions
  const displayMilestones = canManage ? getAllSteps() : getPublicSteps();

  return (
    <MilestoneProgress milestones={displayMilestones} isMobile={isMobile} />
  );
};

export default Milestone;
